import React from 'react'
import {
  Row,
  Input,
  Col,
  Button,
  Form,
  Select,
  Modal,
  Table,
  DatePicker,
  Popconfirm,
  Layout,
  message,
} from 'antd'
class AddUnderwriter extends React.Component {
  constructor() {
    super()
    this.state = {
      products: JSON.parse(localStorage.getItem('roles')),
      username: localStorage.getItem('username'),
      underwriterFirstName: '',
      underwriterLastName: '',
      underwriterEmail: '',
      underwriterContact: '',
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleSubmit = e => {
    e.preventDefault()
    var res = {
      underwriter_Id: 0,
      first_name: this.state.underwriterFirstName,
      last_name: this.state.underwriterLastName,
      email: this.state.underwriterEmail,
      contact: this.state.underwriterContact,
    }
    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(res),
    }
    fetch(
      process.env.REACT_APP_BASE_URL_ADMIN + '/Oversight/AddUpdateProduct',
      requestMetadata,
    ).then(res => {
      if (res.status === 200) {
        message.success('Underwriter Added Successfully !!')
        window.location.reload(false)
      }
    })
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  render() {
    return (
      <div className="container container-center">
        <p>Add Underwriter</p>
        <Form onSubmit={this.handleSubmit}>
          <label>
            First Name:
            <input
              type="text"
              name="underwriterFirstName"
              value={this.state.underwriterFirstName}
              onChange={this.handleChange}
            />
          </label>
          <br />

          <label>
            Last Name:
            <input
              type="text"
              name="underwriterLastName"
              value={this.state.underwriterLastName}
              onChange={this.handleChange}
            />
          </label>
          <br />

          <label>
            Email:
            <input
              type="email"
              name="underwriterEmail"
              value={this.state.underwriterEmail}
              onChange={this.handleChange}
            />
          </label>
          <br />

          <label>
            Contact:
            <input
              type="text"
              name="underwriterContact"
              value={this.state.underwriterContact}
              onChange={this.handleChange}
            />
          </label>
          <br />
          <button type="submit">Submit</button>
        </Form>
      </div>
    )
  }
}

export default AddUnderwriter
